import { Box, Checkbox, Typography } from '@mui/material';
import { PriceInput } from '../PriceInput/PriceInput';
import { SelectedType } from './useSetExclusive';
import { PriceFormRow } from './types';

type PriceFormProps = {
  errors: { monthly?: string; annual?: string };
  isSubmitting: boolean;
  selectedType: SelectedType;
  selectType: (p: { key: keyof SelectedType; value: boolean }) => void;
  formData: PriceFormRow[];
};

export const PriceForm = ({
  errors,
  isSubmitting,
  formData,
  selectedType,
  selectType,
}: PriceFormProps) => {
  return (
    <Box>
      {formData.map(({ key, checkboxLabel, inputLabel, onChange }) => (
        <Box
          key={key}
          sx={{
            padding: '10px 32px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              sx={{ paddingLeft: 0 }}
              checked={selectedType[key]}
              onChange={(ev) => selectType({ key, value: ev.target.checked })}
            />
            <Typography>{checkboxLabel}</Typography>
          </Box>
          {selectedType[key] ? (
            <>
              <Typography sx={{ paddingBottom: '4px', fontWeight: 600 }}>
                {inputLabel}
              </Typography>
              <PriceInput
                disabled={isSubmitting}
                error={errors[key]}
                onChange={onChange}
                placeholder="Please enter"
              />
            </>
          ) : null}
        </Box>
      ))}
    </Box>
  );
};
